export const PaymentBadge = ({ children, label }: { children: React.ReactNode; label: string }) => (
  <span
    role="img"
    aria-label={label}
    className="inline-flex items-center justify-center h-8 min-w-[3.25rem] whitespace-nowrap rounded-md bg-white shadow-sm shadow-black/20 ring-1 ring-black/5 px-2.5"
  >
    {children}
  </span>
)

export const VisaMark = () => (
  <PaymentBadge label="Visa">
    <svg viewBox="0 0 48 16" className="h-3.5 w-auto" xmlns="http://www.w3.org/2000/svg">
      <text
        x="0" y="13"
        fontFamily="Arial, Helvetica, sans-serif"
        fontStyle="italic"
        fontWeight="800"
        fontSize="16"
        letterSpacing="-0.5"
        fill="#1434CB"
      >
        VISA
      </text>
    </svg>
  </PaymentBadge>
)

export const MastercardMark = () => (
  <PaymentBadge label="Mastercard">
    <svg viewBox="0 0 32 20" className="h-4 w-auto" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="10" r="9" fill="#EB001B" />
      <circle cx="20" cy="10" r="9" fill="#F79E1B" />
      <path
        d="M16 3.5a9 9 0 0 1 0 13 9 9 0 0 1 0-13z"
        fill="#FF5F00"
      />
    </svg>
  </PaymentBadge>
)

export const ElcardMark = () => (
  <PaymentBadge label="Элкарт">
    <span className="text-[11px] font-extrabold tracking-tight text-gray-800 leading-none whitespace-nowrap">
      Элкарт
    </span>
  </PaymentBadge>
)